module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number-input-mask"
  }, [_c('div', {
    staticClass: "input-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    ref: "input",
    staticClass: "number-area",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('1')
      }
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('2')
      }
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('3')
      }
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": _vm.removeNumber
    }
  }, [_vm._v("DEL")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('4')
      }
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('5')
      }
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('6')
      }
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('7')
      }
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('8')
      }
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('9')
      }
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "bg-number-button bg-number-bottom",
    on: {
      "click": function($event) {
        return _vm.addNumber('0')
      }
    }
  }, [_vm._v("0")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "bg-number-button bg-number-right",
    on: {
      "click": _vm.saveNumber
    }
  }, [_vm._v("確認")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71119b0d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/NumberInput.vue
// module id = 1507
// module chunks = 1